export const STORE_TRANSLATIONS = {
  TITLE: 'My Exco Store',
  ACTIVE_MODULE: 'Module activé',
  PER_MONTH: 'ht/mois',
};
